import { type FC, memo, useMemo } from "react";
import { Text } from "@stubhub/broadway-web";
import { useContent } from "src/shared/components/content";
import { calendarHeaderContainer, calendarHeaderContainerStatic, calendarWeekdayContainer } from "./styles";

interface Props {
  isResidency?: boolean;
}

export const CalendarHeader: FC<Props> = memo(({ isResidency }) => {
  const sunContent = useContent("cid$#3562197#"); // "Sun"
  const monContent = useContent("cid$#3562198#"); // "Mon"
  const tueContent = useContent("cid$#3562199#"); // "Tue"
  const wedContent = useContent("cid$#3562200#"); // "Wed"
  const thuContent = useContent("cid$#3562201#"); // "Thu"
  const friContent = useContent("cid$#3562202#"); // "Fri"
  const satContent = useContent("cid$#3562203#"); // "Sat"

  const daysOfWeek = useMemo(
    () => [sunContent, monContent, tueContent, wedContent, thuContent, friContent, satContent],
    [sunContent, monContent, tueContent, wedContent, thuContent, friContent, satContent],
  );

  return (
    <div className={isResidency ? calendarHeaderContainerStatic : calendarHeaderContainer}>
      <div className={calendarWeekdayContainer()}>
        {daysOfWeek.map((day) => (
          <Text key={day} variant="label" size="medium">
            {day}
          </Text>
        ))}
      </div>
    </div>
  );
});
CalendarHeader.displayName = "CalendarHeader";
